import { error } from "console";
import { CommonService } from "src/app/services/common.service";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
declare var bootstrap: any;

@Component({
  selector: "app-instructor-dashboard",
  templateUrl: "./instructor-dashboard.component.html",
  styleUrls: ["./instructor-dashboard.component.css"],
})
export class InstructorDashboardComponent implements OnInit {
  dashboardData: Array<any> = [];
  CapturedMarks: Array<any> = [];
  StudentsByProgramme: Array<any> = [];
  creditTransferCount: any;
  exemptionCount: any;
  assignedCourses: any;
  desiredUrl: any;

  constructor(
    private CommonService: CommonService,
    private toastr: ToastrService,
    private router: Router
  ) {}
  ngOnInit(): void {
    this.getInstructorDashboardCount();
    this.getMoodleUrl();
  }
  getInstructorDashboardCount() {
    this.CommonService.activateSpinner();
    const payload = {
      tnt_code: localStorage.getItem("TenantCode"),
      trainer_id: localStorage.getItem("UserId"),
    };

    this.CommonService.postCall(
      "Dashboard/LoadInstructorDashboardCount",
      payload
    ).subscribe({
      next: (res: any) => {
        if (!res) {
          this.toastr.warning("No dashboard data found.");
          this.CommonService.deactivateSpinner();
          return;
        }

        this.dashboardData = res?.DashboardCount || [];
        this.creditTransferCount = this.dashboardData.find(
          (x) => x.type1?.toLowerCase() === "credit transfer"
        );
        this.exemptionCount = this.dashboardData.find(
          (x) => x.type1?.toLowerCase() === "exemption"
        );
        this.assignedCourses = this.dashboardData.find(
          (x) => x.type1?.toLowerCase() === "assigned courses"
        );
        this.CapturedMarks = res?.CapturedMarks || [];

        if (this.CapturedMarks.length > 0) {
          this.getGetStudentsByProgramme(this.CapturedMarks[0]?.subject_id);
        }

        this.CommonService.deactivateSpinner();
      },
      error: (e) => {
        this.toastr.error("Error loading dashboard data");
        this.CommonService.deactivateSpinner();
      },
    });
  }

  getGetStudentsByProgramme(event: any) {
    this.CommonService.activateSpinner();
    this.CommonService.postCall("Dashboard/GetStudentsByProgramme", {
      tnt_code: localStorage.getItem("TenantCode"),
      courseshd_subject: event,
    }).subscribe(
      (res: any) => {
        this.StudentsByProgramme = res;
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.toastr.error(e.error.message);
        this.CommonService.deactivateSpinner();
      }
    );
  }
  getProgress(item: any): number {
    const total = item?.total_users || 0;
    const count = item?.marks_count || 0;
    return total > 0 ? Math.round((count / total) * 100) : 0;
  }

  getProgressByProgram(item: any): number {
    const total = item?.total_count || 0;
    const registered = item?.registered_count || 0;
    return total > 0 ? Math.round((registered / total) * 100) : 0;
  }

  getMoodleUrl() {
    const payload = {
      WSTOKEN: localStorage.getItem("MoodleTkn"),
      username: localStorage.getItem("MoodleUserName"),
      COURSE_ID: 0,
    };

    this.CommonService.activateSpinner();
    this.CommonService.postCall(
      "MoodleIntegration/GetMoodleRequestLoginURL",
      payload
    ).subscribe({
      next: (res: any) => {
        if (res?.userToken) {
          localStorage.setItem("MoodleTkn", res.userToken);
        }

        if (res?.LoginUrl) {
          const [baseUrl] = res.LoginUrl.split("&wantsurl=");
          this.desiredUrl = baseUrl;
        } else {
          this.toastr.warning("Unable to get Moodle login URL.");
        }

        this.CommonService.deactivateSpinner();
      },
      error: (e) => {
        this.toastr.error(e?.error?.message || "User doesn't exist on LMS");
        this.CommonService.deactivateSpinner();
      },
    });
  }

  openInNewTab(event?: Event) {
    if (!this.desiredUrl) {
      this.toastr.warning("LMS link not available.");
      return;
    }
    window.open(this.desiredUrl, "_blank", "noopener");
    event?.preventDefault();
  }
  openProgrammeModal() {
    const modalElement = document.getElementById("programmeModal");
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }
}
